var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.553 22.133C15.113 22.08 11.032 21.516 6.75798 17.243C2.48498 12.969 1.92198 8.88897 1.86798 7.44797C1.78798 5.25197 3.46998 3.11897 5.41298 2.28597C5.64695 2.18494 5.90318 2.14647 6.15651 2.17435C6.40984 2.20222 6.65157 2.29548 6.85798 2.44497C8.45798 3.61097 9.56198 5.37497 10.51 6.76197C10.7186 7.0667 10.8077 7.43752 10.7605 7.80377C10.7133 8.17002 10.533 8.5061 10.254 8.74797L8.30298 10.197C8.20872 10.265 8.14237 10.365 8.11625 10.4783C8.09014 10.5916 8.10603 10.7105 8.16098 10.813C8.60298 11.616 9.38898 12.812 10.289 13.712C11.189 14.612 12.442 15.45 13.301 15.942C13.4087 16.0024 13.5355 16.0193 13.6552 15.9892C13.775 15.9591 13.8787 15.8842 13.945 15.78L15.215 13.847C15.4485 13.5368 15.7929 13.329 16.1762 13.2672C16.5594 13.2053 16.9517 13.2941 17.271 13.515C18.678 14.489 20.32 15.574 21.522 17.113C21.6836 17.3209 21.7864 17.5684 21.8197 17.8296C21.8529 18.0908 21.8154 18.3562 21.711 18.598C20.874 20.551 18.756 22.214 16.553 22.133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.3d655049348a3c85601f90a7504ab7b5.svg";
export { ForwardRef as ReactComponent };